import SuspenseLoader from 'component/base/Loading/SuspenseLoader';
import AppLayout from 'component/layout/AppLayout';
import ContentLayout from 'component/layout/ContentLayout';
import { RoutePath } from 'enums/routePath';
import routePaths from 'pages/routePaths';
import React, { lazy } from 'react';
import { useRouteMatch } from 'react-router-dom';

const BenchmarkingPage = lazy(() => import('pages/BenchmarkingPage'));

const LazyBenchmarkingPage = () => (
  <SuspenseLoader
    publicPath={routePaths[RoutePath.ACTIVITY_MAP]}
    filePath="pages/BenchmarkingPage"
  >
    <BenchmarkingPage />
  </SuspenseLoader>
);

const AppPage = () => {
  const settingsMatch = !!useRouteMatch(routePaths[RoutePath.SETTINGS]);
  const { isExact } = useRouteMatch({
    path: routePaths[RoutePath.HOME],
    strict: true,
  }) || { isExact: false };

  return (
    <AppLayout preventChildrenOverride={settingsMatch}>
      <ContentLayout
        containerProps={{ backgroundColor: isExact ? '#fff' : undefined }}
      >
        <LazyBenchmarkingPage />
      </ContentLayout>
    </AppLayout>
  );
};

export default AppPage;
